import React from "react";
import styled from "styled-components";

import { Breadcrumb as BreadcrumbPlugin } from "gatsby-plugin-breadcrumb";
import { Container } from "@util/standard";
import {
  colorsRGB,
  isEveryday,
  slug,
  TABLET_BREAKPOINT,
} from "@util/constants";
import { BreadcrumbPageContext, Crumbs } from "@util/types";

interface Props {
  crumbLabel?: string;
  title?: string;
  crumbSeparator?: string;
  hiddenCrumbs?: any[];
  disableLinks?: any[];
  pageContext?: BreadcrumbPageContext;
  parentCrumb?: Crumbs | undefined;
  colour?: string;
}

const BreadcrumbContainer = styled(Container)<{ colour?: string }>`
  .breadcrumb__list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-flow: row wrap;
    list-style: none;
    padding: 0 50px;

    li a {
      color: ${props => (props.colour ? props.colour : colorsRGB.merlin(0.5))};
    }
  }
  .breadcrumb__separator {
    margin: 0 10px;
    color: ${props => (props.colour ? props.colour : colorsRGB.merlin(0.5))};
  }
  a {
    color: ${props => (props.colour ? props.colour : colorsRGB.merlin(0.5))};

    text-transform: capitalize;
    transition: color 0.3s ease;
    &:hover {
      color: ${props => (props.colour ? props.colour : colorsRGB.merlin(1))};
      opacity: 1;
    }
  }
`;

const Breadcrumb = ({
  crumbLabel,
  title,
  crumbSeparator = "|",
  hiddenCrumbs,
  disableLinks,
  pageContext,
  parentCrumb,
  colour,
}: Props) => {
  if (pageContext?.breadcrumb?.crumbs == null) return null;

  const {
    breadcrumb: { crumbs },
  } = pageContext;

  const crumbsCleaned = crumbs.map(crumb => {
    if (crumb.pathname === "/recipe") {
      return {
        crumbLabel: "Recipes",
        pathname: `/${slug.recipes}`,
      };
    }

    if (crumb.pathname === "/shop") {
      return {
        crumbLabel: "Shop All",
        pathname: `/${slug.shopAll}`,
      };
    }

    if (crumb.pathname === "/blog") {
      return {
        crumbLabel: isEveryday ? "Blog" : "Food Journal",
        pathname: `/${slug.blog}`,
      };
    }

    return {
      crumbLabel: crumb.crumbLabel.replace(/-/g, " "),
      pathname: crumb.pathname,
    };
  });

  if (!isEveryday && parentCrumb?.crumbLabel) {
    crumbsCleaned.splice(crumbsCleaned.length - 1, 0, parentCrumb);
  }

  return (
    <BreadcrumbContainer colour={colour}>
      <BreadcrumbPlugin
        crumbs={crumbsCleaned}
        crumbLabel={crumbLabel}
        title={title}
        crumbSeparator={crumbSeparator}
        hiddenCrumbs={hiddenCrumbs}
        disableLinks={disableLinks}
      />
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;
